import { UserCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/user_events_pb';
import { Col, humanReadableDateTime } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';
import { getLocale } from '~/shared/utils/locale';

type UserCreatedDetailProps = {
  event: UserCreatedEvent;
};

export const UserCreatedDetail = ({ event }: UserCreatedDetailProps) => {
  const user = event.user;

  if (!user) {
    return (
      <Col className="@UserCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const createdAtStr = protoTimestampToZonedDateTimeString(user.createdAt);

  return (
    <Col className="@UserCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          User Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={user.id?.value} />
          <FieldDisplay label="IDP ID" value={user.idpId} />
          <FieldDisplay label="First Name" value={user.firstName} />
          <FieldDisplay label="Last Name" value={user.lastName} />
          <FieldDisplay label="Email" value={user.email} />
          <FieldDisplay label="Phone Number" value={user.phoneNumber} />
          <FieldDisplay label="Timezone" value={user.timezone?.name} />
          {createdAtStr && (
            <FieldDisplay
              label="Created At"
              value={humanReadableDateTime(createdAtStr, {
                locale: getLocale(),
              })}
            />
          )}
        </div>
      </Col>
    </Col>
  );
};
